import { Route, Routes } from 'react-router-dom';
import CategoryListPage from './list';

export default function CategoryRouting() {
  return (
    <Routes>
      <Route index element={<CategoryListPage />} />
    </Routes>
  );
}
